import styled from "styled-components"
import media from "src/styles/media"

export const SearchBoxWrapper = styled.div`
  .ais-SearchBox {
    padding: 10px 23% 20px 23%;

    ${media.lessThan("lg")`
        padding: 15px 10%;
    `}
  }

  .ais-SearchBox-input {
    font-family: "BG-R";
    display: flex;
    width: 100%;
    background: none;
    border: none;
    border: 1.2px solid var(--dark);
    color: var(--dark);
    border-radius: 26px;
    font-size: 19px;
    padding: 7px 26px;
    transition: border 0.3s;

    ${media.lessThan("lg")`
        padding: 7px 19px;
        font-size: 19px;
        border-width: 1px;
    `}

    &::placeholder {
      color: var(--dark);
    }

    &:focus {
      box-shadow: none;
      outline: none;
    }
  }
  .ais-SearchBox-submit,
  .ais-SearchBox-reset {
    display: none;
  }
`

export const SearchBoxTitle = styled.h3`
  font-size: 34px;
  font-weight: bold;
  color: var(--navy);
  margin-bottom: 15px;
  text-align: center;

  ${media.lessThan("md")`
        font-size: 30px;
        margin-bottom: 15px;
    `}
`
